import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-between" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 리드엔젤 성과보수 ")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 없음 ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 거래 수수료 1% ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 거래 완료시 조건에 따라 부과 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ion_label = _resolveComponent("ion-label")!

  return (_openBlock(), _createBlock(_component_ag_box, { width: "100%" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ion_label, null, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, {
              "margin-bottom": "16px",
              dp: 'flex',
              "align-items": 'center'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box, {
                  width: "24px",
                  height: "24px",
                  style: {"border-radius":"100%","position":"relative"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "img-circle img-responsive",
                      src: _ctx.dealInfo.partnershipLogo
                    }, null, 8, _hoisted_2),
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_text, {
                  color: "black",
                  dp: 'inline-block',
                  "margin-left": "8px",
                  typography: 'list16m'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.dealInfo.partnershipName), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_ag_box, {
          dp: "flex",
          "justify-content": "space-between",
          "margin-bottom": "8px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_text, {
              color: 'gray3',
              typography: 'main14r'
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 판매 " + _toDisplayString(_ctx.componentNumberName) + " 주당 가격 ", 1)
              ]),
              _: 1
            }),
            (_ctx.componentNumberRef < 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_ag_text, {
                    color: _ctx.sellPriceRef ? 'black' : 'gray3',
                    typography: 'num14bk'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.sellPriceRef ? _ctx.$filters.currency(_ctx.sellPriceRef) : '-'), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]),
                  _createVNode(_component_ag_text, {
                    color: _ctx.sellPriceRef ? 'black' : 'gray3',
                    typography: 'main14r'
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_ag_text, {
                    color: _ctx.sellPriceRef ? 'black' : 'gray3',
                    typography: 'num14bk'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.expectedPriceRef)), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]),
                  _createVNode(_component_ag_text, {
                    color: "black",
                    typography: 'main14r'
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _: 1
        }),
        _createVNode(_component_ag_box, {
          dp: "flex",
          "justify-content": "space-between",
          "margin-bottom": "8px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_text, {
              color: 'gray3',
              typography: 'main14r'
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 판매 " + _toDisplayString(_ctx.componentNumberName) + " 금액 ", 1)
              ]),
              _: 1
            }),
            (_ctx.componentNumberRef < 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_ag_text, {
                    color: _ctx.sellAmountRef ? 'black' : 'gray3',
                    typography: 'num14bk'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.sellAmountRef ? _ctx.$filters.currency(_ctx.sellAmountRef) : '-'), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]),
                  _createVNode(_component_ag_text, {
                    color: _ctx.sellAmountRef ? 'black' : 'gray3',
                    typography: 'main14r'
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_ag_text, {
                    color: _ctx.sellAmountRef ? 'black' : 'gray3',
                    typography: 'num14bk'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.expectedTotalPriceRef)), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]),
                  _createVNode(_component_ag_text, {
                    color: "black",
                    typography: 'main14r'
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_ag_box, {
          dp: "flex",
          "justify-content": "space-between",
          "margin-bottom": "8px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_text, {
              color: 'gray3',
              typography: 'main14r'
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            (_ctx.carriedInterestRef)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_ag_text, {
                    color: "black",
                    typography: 'num14bk'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.carriedInterestRef)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_text, {
                    color: "black",
                    typography: 'main14r'
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_ag_text, {
                    color: "black",
                    typography: 'main14r'
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.componentNumberRef === 5]
        ]),
        _withDirectives(_createVNode(_component_ag_box, {
          dp: "flex",
          "justify-content": "space-between",
          "margin-bottom": "8px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_text, {
              color: 'gray3',
              typography: 'main14r'
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_ag_text, {
                color: "black",
                typography: 'main14r'
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.componentNumberRef === 5]
        ])
      ])
    ]),
    _: 1
  }))
}